module.exports = __webpack_public_path__ + "img/logo_white.3e4e9a67.svg";